<tgrid-top-nav></tgrid-top-nav>

<vulcan-side-nav [config]="config()">

  <vulcan-nav-item route="app" icon="house" displayText="Home"></vulcan-nav-item>

  <vulcan-nav-item route="map" icon="globe-hemisphere-west" displayText="Map"></vulcan-nav-item>
  <vulcan-nav-item route="reports" icon="folders" displayText="Reports"></vulcan-nav-item>
  <vulcan-nav-item route="communities" icon="users-four" displayText="Communites"></vulcan-nav-item>


  <vulcan-nav-item route="help" icon="question" displayText="Help"></vulcan-nav-item>


  <vulcan-content>
    <div class="main-app-content">
      <router-outlet></router-outlet>
    </div>
  </vulcan-content>

</vulcan-side-nav>


@if (locationService.loadingCounties()) {
  <div class="county-loading-chip">
    <span>Loading County Boundaries</span>
    <mat-icon class="rotate-hourglass" inline>hourglass_top</mat-icon>
  </div>
}

@if (!authService.isSessionConnected()) {
  <div class="full-page-mask">
    <div class="session-mask">
      <p>
        <mat-icon>info_outlined</mat-icon>
        <span>
          Your session has expired.
          <br>
            You will need to <a routerLink="/login">login</a>.
          </span>
          <mat-icon>info_outlined</mat-icon>
        </p>
      </div>
    </div>
  }
